export const quizTranslations = {
  fr: {
    title: "Quiz Médical IA",
    subtitle: "Testez vos connaissances avec l'intelligence artificielle",
    backButton: "Retour",
    configureTitle: "Configuration du Quiz",
    topicLabel: "Sujet du quiz",
    topicPlaceholder: "Ex: Cardiologie, Urgences, Médicaments...",
    difficultyLabel: "Niveau de difficulté",
    questionsLabel: "Nombre de questions",
    questions: {
      "3": "3 questions",
      "5": "5 questions", 
      "10": "10 questions",
      "15": "15 questions"
    },
    generateButton: "Générer le Quiz",
    generating: "Génération du quiz...",
    startQuiz: "Commencer le Quiz",
    quizCompleted: "Quiz Terminé",
    finalScore: "Score: {{score}}/{{total}}",
    questionCounter: "Question {{current}}/{{total}}",
    score: "Score: {{score}}",
    nextQuestion: "Question suivante",
    showExplanation: "Voir l'explication",
    hideExplanation: "Masquer l'explication",
    newQuiz: "Nouveau Quiz",
    viewResults: "Voir les résultats",
    difficulties: {
      easy: "Facile",
      medium: "Moyen",
      hard: "Difficile"
    },
    scoreMessages: {
      excellent: "Excellent ! Vous maîtrisez parfaitement le sujet.",
      good: "Très bien ! Vous avez de bonnes connaissances.",
      average: "Pas mal ! Il y a encore quelques points à améliorer.",
      needsWork: "Continuez à étudier pour améliorer vos résultats."
    },
    percentage: "{{percentage}}% de bonnes réponses",
    timeSpent: "Temps : {{time}}",
    xpEarned: "+{{xp}} XP gagnés",
    achievements: "🏆 {{achievements}}",
    generateFlashcards: "Créer des flashcards",
    restartQuiz: "Recommencer",
    submitAnswer: "Valider",
    previousQuestion: "Précédent",
    correct: "Correct !",
    incorrect: "Incorrect",
    explanation: "Explication",
    finish: "Terminer",
    toasts: {
      generationError: "Erreur lors de la génération du quiz",
      quizGenerated: "Quiz généré avec {{count}} questions",
      quizSaved: "Quiz sauvegardé"
    }
  },
  en: {
    title: "Medical AI Quiz",
    subtitle: "Test your knowledge with artificial intelligence",
    backButton: "Back",
    configureTitle: "Quiz Configuration",
    topicLabel: "Quiz topic",
    topicPlaceholder: "Ex: Cardiology, Emergency, Medications...",
    difficultyLabel: "Difficulty level",
    questionsLabel: "Number of questions",
    questions: {
      "3": "3 questions",
      "5": "5 questions", 
      "10": "10 questions",
      "15": "15 questions"
    },
    generateButton: "Generate Quiz",
    generating: "Generating quiz...",
    startQuiz: "Start Quiz",
    quizCompleted: "Quiz Completed",
    finalScore: "Score: {{score}}/{{total}}",
    questionCounter: "Question {{current}}/{{total}}",
    score: "Score: {{score}}",
    nextQuestion: "Next question",
    showExplanation: "Show explanation",
    hideExplanation: "Hide explanation",
    newQuiz: "New Quiz",
    viewResults: "View results",
    difficulties: {
      easy: "Easy",
      medium: "Medium",
      hard: "Hard"
    },
    scoreMessages: {
      excellent: "Excellent! You have mastered the subject perfectly.",
      good: "Very good! You have good knowledge.",
      average: "Not bad! There are still some points to improve.",
      needsWork: "Keep studying to improve your results."
    },
    percentage: "{{percentage}}% correct answers",
    timeSpent: "Time: {{time}}",
    xpEarned: "+{{xp}} XP earned",
    achievements: "🏆 {{achievements}}",
    generateFlashcards: "Create flashcards",
    restartQuiz: "Restart",
    submitAnswer: "Submit",
    previousQuestion: "Previous",
    correct: "Correct!",
    incorrect: "Incorrect",
    explanation: "Explanation",
    finish: "Finish",
    toasts: {
      generationError: "Error generating quiz",
      quizGenerated: "Quiz generated with {{count}} questions",
      quizSaved: "Quiz saved"
    }
  },
  es: {
    title: "Quiz Médico IA",
    subtitle: "Pon a prueba tus conocimientos con inteligencia artificial",
    backButton: "Volver",
    configureTitle: "Configuración del Quiz",
    topicLabel: "Tema del quiz",
    topicPlaceholder: "Ej: Cardiología, Urgencias, Medicamentos...",
    difficultyLabel: "Nivel de dificultad",
    questionsLabel: "Número de preguntas",
    questions: {
      "3": "3 preguntas",
      "5": "5 preguntas", 
      "10": "10 preguntas",
      "15": "15 preguntas"
    },
    generateButton: "Generar Quiz",
    generating: "Generando quiz...",
    startQuiz: "Iniciar Quiz",
    quizCompleted: "Quiz Completado",
    finalScore: "Puntuación: {{score}}/{{total}}",
    questionCounter: "Pregunta {{current}}/{{total}}",
    score: "Puntuación: {{score}}",
    nextQuestion: "Siguiente pregunta",
    showExplanation: "Mostrar explicación",
    hideExplanation: "Ocultar explicación",
    newQuiz: "Nuevo Quiz",
    viewResults: "Ver resultados",
    difficulties: {
      easy: "Fácil",
      medium: "Medio",
      hard: "Difícil"
    },
    scoreMessages: {
      excellent: "¡Excelente! Dominas perfectamente el tema.",
      good: "¡Muy bien! Tienes buenos conocimientos.",
      average: "¡No está mal! Todavía hay algunos puntos que mejorar.",
      needsWork: "Sigue estudiando para mejorar tus resultados."
    },
    percentage: "{{percentage}}% de respuestas correctas",
    timeSpent: "Tiempo: {{time}}",
    xpEarned: "+{{xp}} XP ganados",
    achievements: "🏆 {{achievements}}",
    generateFlashcards: "Crear flashcards",
    restartQuiz: "Reiniciar",
    submitAnswer: "Enviar",
    previousQuestion: "Anterior",
    correct: "¡Correcto!",
    incorrect: "Incorrecto",
    explanation: "Explicación",
    finish: "Terminar",
    toasts: {
      generationError: "Error al generar el quiz",
      quizGenerated: "Quiz generado con {{count}} preguntas",
      quizSaved: "Quiz guardado"
    }
  }
};